<template>
  <div class="ProgressNavItem">
    <div
      class="ProgressNavItem-filledBar"
      :style="{ transform: `translate3d(-${(1 - progress) * 100}%, 0, 0)` }"
    ></div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";

import "@/components/ProgressNavItem/ProgressNavItem.scss";

export default {
  name: "ProgressNavItem",

  data () {
    return {
      progress: 0,
    };
  },

  props: {
    itemId: {
      type: [String],
      required: true,
    },
  },

  methods: {
    handleScroll () {
      const nodeElement = document.querySelectorAll('[data-scroll="' + this.itemId + '"]');

      if (!nodeElement.length) return;

      let offsetTop = 0;
      let clientHeight = 0;
      if (nodeElement.length > 1) {
        nodeElement.forEach(element => {
          offsetTop = nodeElement[0].offsetTop;
          clientHeight = clientHeight + element.clientHeight;
        });
      } else {
        offsetTop = nodeElement[0].offsetTop;
        clientHeight = nodeElement[0].clientHeight;
      }

      let progress = [];
      if (offsetTop) {
        progress = (window.scrollY - offsetTop + 200) / clientHeight;
      }

      if (progress > 1) {
        this.progress = 1;
      } else if (progress < 0) {
        this.progress = 0;
      } else {
        this.progress = progress;
      }
    },
  },

  created () {
    this.handleDebouncedScroll = debounce(this.handleScroll, 1);
    window.addEventListener("scroll", this.handleDebouncedScroll);
  },

  beforeDestroy () {
    window.removeEventListener("scroll", this.handleDebouncedScroll);
  },
};
</script>
